import { AuthenticatedAccount } from '@client:common/AuthenticatedAccount';
import { IChatMessage } from "../models/chat-message";
import { IStreamingCompletionResponse, StreamingCompletionResponse } from '../models/completion-response';

export interface ICompletionService {
  completion(messages: IChatMessage[], accessToken: string): Promise<IStreamingCompletionResponse>
}

export class CompletionService implements ICompletionService {
  private sessionId: string;
  authenticatedAccount: AuthenticatedAccount | null;

  constructor(sessionId: string) {
    this.sessionId = sessionId;
    this.authenticatedAccount = null;
  }

  async completion(messages: IChatMessage[], accessToken: string): Promise<IStreamingCompletionResponse> {
    const serializedPrompt = CompletionService.convertMessagesToPrompt(messages);

    const response = await fetch('https://ii5v6cg5v3a3fu24ewy22im2ya0ywcxu.lambda-url.us-west-2.on.aws/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sessionId: this.sessionId,
        prompt: serializedPrompt,
        accessToken
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Streaming API request failed:', response.status, errorText);
      throw new Error(`Streaming API request failed: ${response.status} ${errorText}`);
    }

    return new StreamingCompletionResponse(response);
  }

  private static convertMessagesToPrompt(messages: IChatMessage[]): string {
    return messages
      .map(msg => `${msg.role}: ${msg.content}`)
      .join('\n\n');
  }
}

export class MockCompletionService implements ICompletionService {
  async completion(__messages__: IChatMessage[]): Promise<IStreamingCompletionResponse> {
    await new Promise(resolve => setTimeout(resolve, 100));

    class MockStreamingCompletionResponse implements IStreamingCompletionResponse {
      async onChunk(callback: (chunk: string) => void): Promise<string> {
        const loremIpsum = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";
        const chunks = loremIpsum.split(' ');
        let fullResponse = "";

        for (const chunk of chunks) {
          const chunkWithSpace = chunk + " ";
          await new Promise(resolve => setTimeout(resolve, 50));
          callback(chunkWithSpace);
          fullResponse += chunkWithSpace;
        }

        return fullResponse.trim();
      }
    }

    return new MockStreamingCompletionResponse();
  }
}
